import { cx } from '@emotion/css';
import React, { useCallback, useEffect, useRef } from 'react';
import SyntaxColoringService from '../../../../services/SyntaxColoringService';
import { useStyles } from './SyntaxColoringInput.styles';
import { getCurrentCursorPosition, setCurrentCursorPosition } from './services/CursorService';
function SyntaxColoringInput({ id, className, encoder, value, onChange, warning, disabled }) {
    const editorRef = useRef(null);
    const offsetRef = useRef(0);
    const classes = useStyles(warning);
    const htmlEncoder = useCallback((val) => new SyntaxColoringService(encoder).encodeHtml(val), [encoder]);
    const html = htmlEncoder(value);
    const saveCursorPosition = () => {
        if (editorRef.current) {
            offsetRef.current = getCurrentCursorPosition(editorRef.current);
        }
    };
    const restoreCursorPosition = () => {
        const editor = editorRef.current;
        if (editor) {
            setCurrentCursorPosition(offsetRef.current, editor);
            editor.focus();
        }
    };
    const handleOnChange = () => {
        var _a;
        saveCursorPosition();
        onChange(((_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.innerText) || '');
    };
    useEffect(restoreCursorPosition, [value]);
    return (React.createElement("div", { id: id, ref: editorRef, className: cx('neo-preview', classes.preview, className), dangerouslySetInnerHTML: { __html: html }, spellCheck: false, onInput: handleOnChange, contentEditable: !disabled }));
}
export default SyntaxColoringInput;
//# sourceMappingURL=SyntaxColoringInput.js.map